<template>
  <transition
  enter-active-class="animate__animated animate__fadeIn animate__faster"
  leave-active-class="animate__animated animate__fadeOut animate__faster">
    <div class="coin-card-customer" v-if="loyaltyThresholds && rewards.length">
      <p><b>CoinCard: {{loyaltyThresholds.customerGroup}}</b></p>
      <div class="untill-next" v-show="untillNextStep && customer">
        <div class="next-step-title">
          <span>{{ $tc('{points}', customer.missingLoyaltyPoints, { points: customer.missingLoyaltyPoints }) }}</span>
          <span> / </span>
          <span>{{loyaltyThresholds.nextStatus}}</span>
        </div>
        <div class="indicator progress-bar" :style="{ width: `${untillNextStep}%` }" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CardCustomer',
  props: {
    customer: {
      type: Object,
      default: () => {}
    },
    rewards: {
      type: Array,
      default: () => []
    },
    loyalty: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    loyaltyThresholds () {
      return this.loyalty
    },
    untillNextStep () {
      if (this.customer) {
        let currentPoint = this.customer.loyaltyPoints * 1000
        const fixedRemove = 4 // remove always something, in this way progress bar is never at the end
        return ((currentPoint / (currentPoint + this.customer.missingLoyaltyPoints)) * 100 - fixedRemove)
      } else {
        return false
      }
    }
  },
  methods: {
    init () {
      // called by reference
      return true
    }
  }
}
</script>
